import React from "react";
import CharacterSheet from "./CharacterSheet";
import { BonusBreakdownContext } from "../contexts/BonusBreakdownContext";
import { RuleItem } from "../interfaces/RuleItem";
import { RuleModule } from "../classes/RuleModule";
import { CurrentBonuses } from "../interfaces/BonusSourceDetails";
import { CalculateSpendableModules } from "../classes/CalculateSpendableModules";
import { SpendablesContext } from "../contexts/SpendablesContext";
import { XPSystemContext } from "../contexts/XPSystemContext";
import { CharacterHistoryContext } from "../contexts/CharacterHistoryContext";
import { RulesContext } from "../contexts/RulesContext";

export default () => {
  const { xpModules } = React.useContext(XPSystemContext);
  const characterHistory = React.useContext(CharacterHistoryContext);
  const rules = React.useContext(RulesContext);
  const currentBonuses: CurrentBonuses = characterHistory.calculateCurrentBonuses(
    rules.allRuleModules(),
    xpModules
  );
  const ruleItems: RuleItem[] = [];
  console.log("Rule Module Count", rules.allRuleModules().length);
  console.log("xpModules", xpModules);
  const ruleModules = rules.allRuleModules();
  ruleModules.forEach((ruleModule: RuleModule) => {
    ruleModule.list.forEach((item: RuleItem) => {
      ruleItems.push({
        ...item,
        name: `${ruleModule.moduleName} - ${item.name}`,
      });
    });
  });
  console.log("ruleItems", ruleItems);
  const moduleSpendables = new CalculateSpendableModules().calculateSpendableModules(
    currentBonuses,
    characterHistory,
    ruleModules,
    xpModules
  );
  console.log(moduleSpendables);
  const globalBonuses = {
    currentBonuses,
    ruleItems,
  };

  return (
    <BonusBreakdownContext.Provider value={globalBonuses}>
      <SpendablesContext.Provider value={{ moduleSpendables }}>
        <CharacterSheet />
      </SpendablesContext.Provider>
    </BonusBreakdownContext.Provider>
  );
};
